import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
var GraduationComponent = (function () {
    function GraduationComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.Arr = Array; //Array type captured in a variable
    }
    GraduationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.learningTourId = params['learningTourId'];
            _this.userId = params['userId'];
            _this.firstEntry = params['firstEntry'];
            _this.getGraduationData();
            //this.getGraduationMockData();
        });
        /*let that = this;
        setTimeout(function () {
            if(that.firstEntry == 1){
                that.openingAnimation();
            }
        },100);*/
        if (this.userId > 0) {
            this.graduationPage = false;
        }
        else {
            this.graduationPage = true;
            this.apiService.ajax({
                'type': 'get',
                'url': '/sr/onceino/301',
                'data': {}
            }).subscribe(function (result) {
                _this.hideStamp = result == 1 ? false : true;
                if (!result) {
                    var that_1 = _this;
                    setTimeout(function () {
                        that_1.openingAnimation();
                    }, 100);
                    _this.apiService.ajax({
                        'type': 'post',
                        'url': '/sr/onceino/301',
                        'data': {}
                    }).subscribe(function (result) {
                    });
                }
            });
        }
    };
    GraduationComponent.prototype.getGraduationData = function () {
        /*this.apiService.getGraduationByLearningPathId("" + this.learningPathId + "", "" + this.userId + "").subscribe(graduation => {
            this.graduation = graduation;
            this.setChart();
        });*/
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/learningtour/' + this.learningTourId + '/graduation/' + this.userId,
            'data': {}
        }).subscribe(function (result) {
            _this.data = result;
            _this.graduation = result.learningPaths[0];
            _this.data = result;
            _this.selectedAbilityIndex = 0;
            _this.characterReport = result.characterReport;
            _this.setChart();
            console.log(_this.graduation);
        });
    };
    GraduationComponent.prototype.setChart = function () {
        var that = this;
        jQuery.getScript("/assets/js/echarts.min.js", function (data, status, jqxhr) {
            if (that.characterReport) {
                var myChart = echarts.init(document.getElementById('radar'));
                var option = {
                    radar: {
                        name: {
                            textStyle: {
                                color: '#4a4a4a',
                                fontSize: 14
                            }
                        },
                        splitArea: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                width: 1,
                                opacity: 0.3,
                                color: '#d1d2d5',
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                width: 1,
                                opacity: 0.3,
                                color: '#d1d2d5',
                            }
                        },
                        indicator: [
                            { name: '尽责', max: 100 },
                            { name: '开放', max: 100 },
                            { name: '情绪稳定', max: 100 },
                            { name: '宜人', max: 100 },
                            { name: '外向', max: 100 }
                        ]
                    },
                    series: [{
                            type: 'radar',
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        color: '#7297e7',
                                        width: 2
                                    }
                                }
                            },
                            data: [
                                {
                                    value: [that.characterReport.responsibility, that.characterReport.open, that.characterReport.emotionality, that.characterReport.delightful, that.characterReport.extroversion],
                                    symbol: 'none',
                                    areaStyle: {
                                        normal: {
                                            opacity: 0.4,
                                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                    offset: 0,
                                                    color: '#63c0f7'
                                                }, {
                                                    offset: 1,
                                                    color: '#7c64ff'
                                                }])
                                        }
                                    }
                                }
                            ]
                        }]
                };
                myChart.setOption(option);
            }
        });
    };
    GraduationComponent.prototype.getGraduationMockData = function () {
        this.graduation = {
            "headimgurl": "http://wx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEJcRMcqnH1PfkfWSkfRLhWv4y3HLvP0DSnLlxF5uy7sRm5MI8GfRoGia6iabF5sicb5C5zRD9uFC31HA/132",
            "userName": "王皓",
            "personalReportStatus": 1,
            "companyName": "Housing Company",
            "rank": 5,
            "lessonCount": 9,
            "questionCount": 51,
            "preSurveyLevel": 2,
            "postSurveyLevel": 3 /*,
            "characterReport":{
                "emotionality":65,
                "delightful":75,
                "extroversion":85,
                "responsibility":95,
                "open":100
            }*/
        };
        var that = this;
        jQuery.getScript("/assets/js/echarts.min.js", function (data, status, jqxhr) {
            var myChart = echarts.init(document.getElementById('radar'));
            var option = {
                radar: {
                    name: {
                        textStyle: {
                            color: '#4a4a4a',
                            fontSize: 14
                        }
                    },
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            width: 1,
                            opacity: 0.3,
                            color: '#d1d2d5',
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            width: 1,
                            opacity: 0.3,
                            color: '#d1d2d5',
                        }
                    },
                    indicator: [
                        { name: '尽责', max: 100 },
                        { name: '开放', max: 100 },
                        { name: '情绪稳定', max: 100 },
                        { name: '宜人', max: 100 },
                        { name: '外向', max: 100 }
                    ]
                },
                series: [{
                        type: 'radar',
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: '#7297e7',
                                    width: 2
                                }
                            }
                        },
                        data: [
                            {
                                value: [65, 55, 75, 85, 90],
                                symbol: 'none',
                                areaStyle: {
                                    normal: {
                                        opacity: 0.4,
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                                offset: 0,
                                                color: '#63c0f7'
                                            }, {
                                                offset: 1,
                                                color: '#7c64ff'
                                            }])
                                    }
                                }
                            }
                        ]
                    }]
            };
            myChart.setOption(option);
        });
    };
    GraduationComponent.prototype.openingAnimation = function () {
        if (this.graduationPage) {
            if (this.graduation.personalReportStatus == 1) {
                document.getElementById("shade").ontouchmove = function (e) { e.preventDefault(); };
                document.getElementById("graduatedPic").ontouchmove = function (e) { e.preventDefault(); };
                document.getElementById("graduatedText").ontouchmove = function (e) { e.preventDefault(); };
                $("#shade").fadeIn(1000);
                $("#graduatedPic").animate({
                    "left": "50%"
                }, 1000);
                $("#graduatedText").animate({
                    "left": "0"
                }, 1000);
                setTimeout(function () {
                    $("#graduatedText").fadeOut();
                    $("#graduatedPic").animate({
                        "width": "1.72rem",
                        "height": "1.72rem",
                        "left": "7.69rem",
                        "top": "5.31rem"
                    }, 1000, function () {
                        $("#shade").fadeOut();
                        $("#graduatedPic").fadeOut();
                        $("#stampGraduated").show();
                    });
                }, 4000);
            }
            else {
                document.getElementById("shade").ontouchmove = function (e) { e.preventDefault(); };
                document.getElementById("failedPic").ontouchmove = function (e) { e.preventDefault(); };
                document.getElementById("failedText").ontouchmove = function (e) { e.preventDefault(); };
                $("#shade").fadeIn(1000);
                $("#failedPic").animate({
                    "left": "50%"
                }, 1000);
                $("#failedText").animate({
                    "left": "0"
                }, 1000);
                setTimeout(function () {
                    $("#failedText").fadeOut();
                    $("#failedPic").animate({
                        "width": "1.92rem",
                        "height": "1.2rem",
                        "left": "7.705rem",
                        "top": "4.81rem"
                    }, 1000, function () {
                        $("#shade").fadeOut();
                        $("#failedPic").fadeOut();
                        $("#stampFailed").show();
                    });
                }, 4000);
            }
        }
    };
    GraduationComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
        var that = this;
        if (this.data) {
            $("#headPortrait").css("background-image", "url(" + this.data.headimgurl + ")");
        }
        else {
            var headerInterval = setInterval(function () {
                if (that.data) {
                    $("#headPortrait").css("background-image", "url(" + that.data.headimgurl + ")");
                    clearInterval(headerInterval);
                }
            }, 100);
        }
    };
    GraduationComponent.prototype.selectAbility = function (index) {
        this.selectedAbilityIndex = index;
    };
    GraduationComponent.prototype.showDnaReport = function () {
        if (this.characterReport) {
            $("#dnaReport").show();
            $("#closeBtnReport2").show();
            $("#dnaReport").animate({
                "top": "0.9rem"
            });
            $("#closeBtnReport2").animate({
                "top": "10rem"
            });
            $("#shade").fadeIn();
            this.scrollTop = document.body.scrollTop | document.documentElement.scrollTop;
            $("#wrap").addClass("fixed");
            $("#wrap").scrollTop(this.scrollTop);
        }
        else {
            $("#noDnaReport").show();
            $("#closeBtnReport2").show();
            $("#noDnaReport").animate({
                "top": "0.9rem"
            });
            $("#closeBtnReport2").animate({
                "top": "10rem"
            });
            $("#shade").fadeIn();
            document.getElementById('noDnaReport').ontouchmove = function (e) {
                e.preventDefault();
            };
            document.getElementById('noDnaReportPic').ontouchmove = function (e) {
                e.preventDefault();
            };
            document.getElementById('noDnaReportText').ontouchmove = function (e) {
                e.preventDefault();
            };
            document.getElementById('shade').ontouchmove = function (e) {
                e.preventDefault();
            };
            document.getElementById('closeBtnReport2').ontouchmove = function (e) {
                e.preventDefault();
            };
        }
    };
    GraduationComponent.prototype.onCloseBtnReportClick = function () {
        if (this.characterReport) {
            $("#dnaReport").animate({
                "top": "20.9rem"
            }, function () {
                $("#dnaReport").hide();
            });
            $("#closeBtnReport2").animate({
                "top": "30rem"
            }, function () {
                $("#closeBtnReport2").hide();
            });
            $("#shade").fadeOut();
            $("#wrap").removeClass("fixed");
            window.scrollTo(0, this.scrollTop);
        }
        else {
            $("#noDnaReport").animate({
                "top": "20.9rem"
            }, function () {
                $("#noDnaReport").hide();
            });
            $("#closeBtnReport2").animate({
                "top": "30rem"
            }, function () {
                $("#closeBtnReport2").hide();
            });
            $("#shade").fadeOut();
        }
    };
    GraduationComponent.prototype.close = function () {
        if (this.userId > 0) {
            var link = ['hr-report'];
            this.router.navigate(link);
        }
        else {
            var link = ['learning-map'];
            this.router.navigate(link);
        }
    };
    return GraduationComponent;
}());
export { GraduationComponent };



// WEBPACK FOOTER //
// ./src/app/graduation/graduation.component.ts.pre-build-optimizer.js